import styled, { css } from 'styled-components';
import { fontSize } from '../../../../mixins';
import { mobileResponsiveXs } from '../common.style';
var StyledH1 = styled.h1.withConfig({
  displayName: "H1style__StyledH1",
  componentId: "sc-1n8ovcg-0"
})(["margin:0;outline:transparent;", ";", ";", ";", ";"], color, light, impact, size);

function color(_ref) {
  var theme = _ref.theme,
      isOnDarkBg = _ref.isOnDarkBg;
  var fontColor = isOnDarkBg ? theme.color.white : theme.color.black;
  return css(["color:", ";"], fontColor);
}

function light(_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return (variant === 'light' || variant !== 'impact') && css(["font-weight:", ";font-family:", ";"], theme.font.weight.light, theme.font.family.primary);
}

function impact(_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return variant === 'impact' && css(["font-weight:", ";font-family:", ";text-transform:uppercase;line-height:", ";"], theme.font.weight.regular, theme.font.family.impact, theme.font.size.xxlg);
}

function size(_ref4) {
  var theme = _ref4.theme,
      shouldResize = _ref4.shouldResize;

  if (shouldResize) {
    return mobileResponsiveXs(theme.font.size.mobile.xxlg, theme.font.size.xxlg, theme.font.lineHeight.mobile.xxlg);
  }

  return css(["", ";"], fontSize(theme.font.size.xxlg));
}

export default StyledH1;